import { BaseService } from '../../infra/base.service'
import type { CreateRecipientDto } from './create-recipient.dto'
import type { Recipient } from './recipient'
import type { RecipientsRepository } from './recipients.repository'

export class RecipientsService extends BaseService<Recipient> {
    constructor(private rep: RecipientsRepository) {
        super(rep)
    }

    async send(dto: CreateRecipientDto) {
        return await this.rep.create(dto as any)
    }

    async getStatus(): Promise<{ status: 'queued' | 'offline' | 'unstable' | 'empty'; since?: Date }> {
        return await this.rep.getStatus()
    }

    async retry(recipientId: string) {
        return await this.rep.retry(recipientId)
    }

    async clearOutbox(service: string, token: string) {
        return await this.rep.clearOutbox(service, token)
    }
}
